window.logger = new (function IngresarLogger() {
    var self = this;
    var types = {
        info: { name: 'info', level: 2 },
        trace: { name: 'trace', level: 0 },
        warn: { name: 'warn', level: 3 },
        debug: { name: 'debug', level: 1 },
        error: { name: 'error', level: 4 },
        fatal: { name: 'fatal', level: 5 }
    }
    var elmahLevel = LN.Config.elmahLevel;


    function post(data) {

        $.ajax({
            url: LN.Config.dominioMiCuenta + '/lgn-log',
            type: 'POST',
            data: JSON.stringify(data),
            async: true,
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            }

        });
    }


    function log(type, message, ex) {
        try {

            if (ex != null && typeof ex == "object") {
                ex = JSON.stringify(ex);
            }

            var values = {
                type: type,
                message: message,
                exception: ex
            };

            if (types[type].level >= types[elmahLevel].level) {
                post(values);
            }
            return self;

        } catch (exp) {
            console.log('Error logueando');
        }
    }

    this.error = function (message, ex) {
        return log(types.error.name, message, ex);
    }

    this.info = function (message, ex) {
        return log(types.info.name, message, ex);
    }

    this.trace = function (message, ex) {
        return log(types.trace.name, message, ex);
    }

    this.warn = function (message, ex) {
        return log(types.warn.name, message, ex);
    }
    this.debug = function (message, ex) {
        return log(types.debug.name, message, ex);
    }
    this.fatal = function (message, ex) {
        return log(types.fatal.name, message, ex);
    }
    this.exception = function (message, ex) {
        return log(types.fatal.name, message, ex);
    }


});




// WEBPACK FOOTER //
// ./Statics/scripts/login/core/logger.js